/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v4-mini";
import { remap as remap$ } from "../../lib/primitives.js";
import { safeParse } from "../../lib/schemas.js";
import { ClosedEnum } from "../../types/enums.js";
import { Result as SafeParseResult } from "../../types/fp.js";
import { SDKValidationError } from "../errors/sdkvalidationerror.js";

/**
 * The processing status of the event.
 */
export const TriggerEventStatus = {
  Pending: "pending",
  Processing: "processing",
  Completed: "completed",
  Failed: "failed",
} as const;
/**
 * The processing status of the event.
 */
export type TriggerEventStatus = ClosedEnum<typeof TriggerEventStatus>;

export type TriggerEvent = {
  /**
   * Number of processing attempts.
   */
  attempts: number;
  /**
   * The conversation the event was routed to.
   */
  chatId?: string | undefined;
  /**
   * Creation timestamp.
   */
  createdAt: Date;
  /**
   * The trigger event ID.
   */
  id: string;
  /**
   * The last processing error, if any.
   */
  lastError?: string | undefined;
  /**
   * Processing completion timestamp.
   */
  processedAt?: Date | undefined;
  /**
   * The processing status of the event.
   */
  status: TriggerEventStatus;
  /**
   * The trigger instance that dispatched the event.
   */
  triggerInstanceId: string;
};

/** @internal */
export const TriggerEventStatus$inboundSchema: z.ZodMiniEnum<
  typeof TriggerEventStatus
> = z.enum(TriggerEventStatus);

/** @internal */
export const TriggerEvent$inboundSchema: z.ZodMiniType<TriggerEvent, unknown> =
  z.pipe(
    z.object({
      attempts: z.int(),
      chat_id: z.optional(z.string()),
      created_at: z.pipe(
        z.iso.datetime({ offset: true }),
        z.transform(v => new Date(v)),
      ),
      id: z.string(),
      last_error: z.optional(z.string()),
      processed_at: z.optional(
        z.pipe(z.iso.datetime({ offset: true }), z.transform(v => new Date(v))),
      ),
      status: TriggerEventStatus$inboundSchema,
      trigger_instance_id: z.string(),
    }),
    z.transform((v) => {
      return remap$(v, {
        "chat_id": "chatId",
        "created_at": "createdAt",
        "last_error": "lastError",
        "processed_at": "processedAt",
        "trigger_instance_id": "triggerInstanceId",
      });
    }),
  );

export function triggerEventFromJSON(
  jsonString: string,
): SafeParseResult<TriggerEvent, SDKValidationError> {
  return safeParse(
    jsonString,
    (x) => TriggerEvent$inboundSchema.parse(JSON.parse(x)),
    `Failed to parse 'TriggerEvent' from JSON`,
  );
}
